module.exports = __webpack_public_path__ + "assets/img/cd7f-ta.svg";